<script>
  import { Image } from 'element-ui'
  export default {
    name:'ElImage',
    extends:Image
  }
</script>
